
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.593 14.02a20.16 20.16 0 004.386 7.597l.01.01A20.48 20.48 0 0022.777 27a.837.837 0 001.088-.575l.002-.005.857-3.2.01-.033a.837.837 0 00-.472-1.005 15.55 15.55 0 01-3.06-1.696l-.003-.002a.836.836 0 00-.899-.048l-1.713.989a1.371 1.371 0 01-1.649-.212 19.04 19.04 0 01-5.048-8.743 1.371 1.371 0 01.641-1.534l1.713-.99a.836.836 0 00.408-.802v-.003a15.545 15.545 0 01.06-3.498.836.836 0 00-.622-.907l-.013-.004-3.198-.857a.84.84 0 00-.913.345.837.837 0 00-.126.312 20.48 20.48 0 00.749 9.476l.003.011zm-2.615.828a22.904 22.904 0 004.977 8.62 23.223 23.223 0 008.845 6.096l.023.009a3.579 3.579 0 004.695-2.445v-.003l.852-3.18a3.58 3.58 0 00-2.038-4.288l-.012-.004a12.807 12.807 0 01-2.525-1.4 3.58 3.58 0 00-3.854-.198l-.79.456a16.298 16.298 0 01-3.313-5.739l.783-.451.006-.004a3.58 3.58 0 001.756-3.438c-.092-.96-.075-1.929.05-2.886l.003-.013a3.58 3.58 0 00-2.654-3.898l-3.195-.856a3.58 3.58 0 00-4.45 2.847l-.004.021a23.223 23.223 0 00.845 10.754z","fill":"#000"}})])
          )
        }
      }
    